var React = require('react');

function SVGLinkExternalWhite (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("path",{"id":"Rectangle","className":"cls-1","d":"M2,2V18H19V2H2M0,0H21V20H0Z","key":1}),React.createElement("g",{"id":"Group_13","data-name":"Group 13","transform":"translate(5.6 6)","key":2},[React.createElement("path",{"id":"Path_4","data-name":"Path 4","className":"cls-1","d":"M.673,8.74-.673,7.26l8.8-8L9.473.74Z","transform":"translate(0 0)","key":0}),React.createElement("path",{"id":"Path_5","data-name":"Path 5","className":"cls-1","d":"M8.812,7.1h-2V1H0V-1H8.812Z","transform":"translate(0.988)","key":1})])]);
}

SVGLinkExternalWhite.defaultProps = {"id":"Group_18","data-name":"Group 18","width":"21","height":"20","viewBox":"0 0 21 20"};

module.exports = SVGLinkExternalWhite;

SVGLinkExternalWhite.default = SVGLinkExternalWhite;
